var _span;
import PropTypes from 'prop-types';
import React, { Fragment, useState, useId } from 'react';
import { createChainedFunction } from '@atc/create-chained-function';
import clsx from 'clsx';
import ErrorMessages from '../ErrorMessages/index.js';
import FormElementLabel from '../FormElementLabel/index.js';
import FormElementHelp from '../FormElementHelp/index.js';

/**
 *  Select will render a standard reaxl form element with available label, help, and error propperties
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Select(_ref) {
  let {
    className,
    disabled,
    errors = [],
    help,
    id,
    label,
    labelProps = {},
    layout = 'vertical',
    multiple = false,
    onBlur,
    options = [],
    selectClassName,
    showErrors,
    value,
    ...rest
  } = _ref;
  const isHorizontalLayout = layout === 'horizontal';
  const isInsideLayout = layout === 'inside';
  let selectValue = [];
  if (value) {
    selectValue = selectValue.concat(value);
  }
  const [hasValue, setHasValue] = useState(!!selectValue?.length);

  // use react18 useId to generate unique id
  const generatedId = useId();
  const _id = id || generatedId;
  const renderOption = option => /*#__PURE__*/_jsx("option", {
    ...option,
    children: option.label
  }, option.value || option.label || option.name);
  const renderedOptions = options.map(option => {
    const _option = {
      ...option
    };

    // remove selected prop if it is supplied
    delete _option.selected;
    if (_option.optgroup) {
      return /*#__PURE__*/_jsx("optgroup", {
        label: _option.optgroup,
        children: _option.options.map(renderOption)
      }, _option.optgroup);
    }
    return renderOption(_option);
  });
  if (isInsideLayout) {
    // Push label to top of option list
    renderedOptions.unshift(/*#__PURE__*/_jsx("option", {
      value: "",
      disabled: hasValue,
      children: labelProps?.label
    }, "label-option"));
  }
  if (!multiple) {
    selectValue = selectValue[0];
  }
  const handleOnBlur = event => {
    setHasValue(!!event?.target?.value);
  };
  const renderSvgIcon = () => _span || (_span = /*#__PURE__*/_jsx("span", {
    className: "custom-input-icon",
    children: /*#__PURE__*/_jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      xmlSpace: "preserve",
      id: "Layer_1",
      x: "0",
      y: "0",
      version: "1.1",
      viewBox: "0 0 16 16",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        d: "M1.6 4.6c.2-.2.5-.2.7 0L8 10.3l5.6-5.6c.2-.2.5-.2.7 0s.2.5 0 .7l-6 6c-.2.2-.5.2-.7 0l-6-6c-.1-.2-.1-.6 0-.8",
        clipRule: "evenodd",
        fill: "var(--comp-color-content-input-icon-rest, var(--sem-color-content-neutral-tertiary, #6d7782))"
      })
    })
  }));
  const elementOnly = /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "custom-select-wrapper",
      children: [/*#__PURE__*/_jsx("select", {
        id: _id,
        className: clsx('form-control', {
          'has-value': hasValue
        }, selectClassName),
        value: selectValue || '',
        multiple: multiple,
        onBlur: createChainedFunction(handleOnBlur, onBlur),
        ...rest,
        disabled: disabled,
        children: renderedOptions
      }, 'select' + _id), renderSvgIcon()]
    }), /*#__PURE__*/_jsx(FormElementHelp, {
      help: help
    }, "elementHelp"), /*#__PURE__*/_jsx(ErrorMessages, {
      errors: errors,
      showErrors: showErrors
    }, "errorMessages")]
  }, "elementOnly");
  if (layout === 'elementOnly') {
    return elementOnly;
  }
  const elementHorizontal = /*#__PURE__*/_jsx("div", {
    className: "col-xs-5",
    children: elementOnly
  }, "elementHorizontal");
  const rootClasses = clsx({
    'row display-flex align-items-baseline': isHorizontalLayout,
    'form-group-inside': isInsideLayout,
    'form-group-inside-label': layout === 'insideLabel',
    'has-value': hasValue
  }, 'form-group form-control-select', className);
  const labelClasses = clsx(labelProps.className, {
    'control-label': !labelProps.className?.includes('control-label')
  });
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "select",
    className: rootClasses,
    children: [/*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(FormElementLabel, {
        label: label,
        ...labelProps,
        htmlFor: labelProps.htmlFor || _id,
        className: labelClasses,
        layout: layout
      })
    }, "label"), isHorizontalLayout ? elementHorizontal : elementOnly]
  });
}
export default Select;